import { isProfileSetupRequiredNotification } from "./applicantProfileNotification";
import {
  getApplicationRejectedListDisplay,
  isApplicationRejectedNotification,
} from "./rejectionNotification";
import {
  getHiringInvitesCompletedListDisplay,
  isHiringInvitesCompletedNotification,
} from "./hiringInviteNotification";

/**
 * Relative time for bell dropdown rows.
 * @param {string | null | undefined} iso
 */
export function formatNotificationRelativeTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const diffMs = Date.now() - d.getTime();
  if (diffMs < 0) return "Just now";
  const mins = Math.floor(diffMs / 60000);
  if (mins < 1) return "Just now";
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `${days}d ago`;
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
}

/**
 * @param {{ type?: string, title?: string, body?: string, payload?: object } | null | undefined} notification
 * @returns {{ kicker: string, heading: string, subtitle: string }}
 */
export function getNotificationListDisplay(notification) {
  if (isApplicationRejectedNotification(notification)) {
    const { heading, subtitle } = getApplicationRejectedListDisplay(notification);
    return { kicker: "Application", heading, subtitle };
  }
  if (isHiringInvitesCompletedNotification(notification)) {
    return getHiringInvitesCompletedListDisplay(notification);
  }
  if (isProfileSetupRequiredNotification(notification)) {
    return {
      kicker: "Profile",
      heading: String(notification?.title || "Complete your profile").trim(),
      subtitle: String(notification?.body || "").trim(),
    };
  }

  const heading = String(notification?.title || "").trim();
  const subtitle = String(notification?.body || "").trim();
  return { kicker: "", heading, subtitle: subtitle === heading ? "" : subtitle };
}

/** @param {{ type?: string } | null | undefined} notification */
export function getNotificationVisualKind(notification) {
  if (isApplicationRejectedNotification(notification)) return "application";
  if (isHiringInvitesCompletedNotification(notification)) return "invites";
  if (isProfileSetupRequiredNotification(notification)) return "profile";
  return "default";
}
